import axios from '@/libs/api.request'

export const advertisePage = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/ad-strategy/page'
  })
}

export const createAdStrategy = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/ad-strategy/create'
  })
}

export const updateAdStrategy = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/ad-strategy/update'
  })
}

export const getAdStrategyInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/ad-strategy/' + id
  })
}


export const delAd = (id) => {
  return axios.request({
    method: 'delete',
    url: '/ad-strategy/delete/' + id
  })
}
